import React from 'react';

import { BreadCrumbs } from 'components/lds';

import { useLabels } from '../../i18n/useLabels';
import type { BreadcrumbViewModel } from '../../viewmodels/createTemplateCustomizationViewModel';

type Props = {
  viewModel: BreadcrumbViewModel[];
  listPageUrl: string;
};

export function TemplateCustomizationBreadcrumbs({
  viewModel,
  listPageUrl,
}: Props) {
  const { formatMessage } = useLabels();

  return (
    <BreadCrumbs
      links={viewModel.map(breadcrumb => ({
        label: formatMessage(breadcrumb),
        url: breadcrumb.isCurrent ? undefined : listPageUrl,
      }))}
    />
  );
}
